import { createAction } from 'redux-actions';

export const fetchProfile = createAction('FETCH_PROFILE');
export const fetchProfileSuccess = createAction('FETCH_PROFILE_SUCCESS');
export const fetchProfileFailure = createAction('FETCH_PROFILE_FAILURE');

export const changeProfilePassword = createAction('CHANGE_PROFILE_PASSWORD');
export const changeProfilePasswordSuccess = createAction('CHANGE_PROFILE_PASSWORD_SUCCESS');
export const changeProfilePasswordFailure = createAction('CHANGE_PROFILE_PASSWORD_FAILURE');

export const updateProfile = createAction('UPDATE_PROFILE');
export const updateProfileSuccess = createAction('UPDATE_PROFILE_SUCCESS');
export const updateProfileFailure = createAction('UPDATE_PROFILE_FAILURE');
